import { CommonModule } from '@angular/common';
import { Component, EventEmitter, ViewChild, viewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClarityModule, ClrForm } from '@clr/angular';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { SonderinspektionmodalComponent } from '../../_modals/sonderinspektionmodal/sonderinspektionmodal.component';
import { PreviewThumbnailsComponent } from '../../_shared/preview-thumbnails/preview-thumbnails.component';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { ConfirmService } from 'src/app/services/confirm.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { MangelMediaApiFuncService } from 'src/app/services/MediaApiFunc/mangel-media-api-func.service';
import { MediaViewModalComponent, TitleAndFileNames } from '../../_shared/mediaviewmodal/mediaviewmodal.component';

@Component({
  selector: 'app-sonderinspektionslistedialog',
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    PreviewThumbnailsComponent,
    SonderinspektionmodalComponent,
    MrTranslatePipe,
    BackendLocaleDatePipe,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
    MediaViewModalComponent,
  ],
  templateUrl: './sonderinspektionslistedialog.component.html',
  styleUrls: ['./sonderinspektionslistedialog.component.scss'],
})
export class SonderinspektionslistedialogComponent {
  private apiservice = inject(APIService);
  private toastr = inject(ToastrService);
  private mrTranslate = inject(MrTranslatePipe);
  protected localeDate = inject(BackendLocaleDatePipe);
  private confirmService = inject(ConfirmService);
  protected authService = inject(AuthService);
  protected media = inject(MangelMediaApiFuncService);

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataRefresh = new EventEmitter();

  constructor() {
    this.formGroupSI.controls.datum.setValue(BackendLocaleDatePipe.now);
  }

  loading: boolean = false;
  set data(dataIn: any) {
    this.loading = true;
    this.dataRefresh = dataIn.dataRefresh;
    this.textpreview = this.mrTranslate.transform('Sonderinspektion wird geladen') + '...';
    this.ostammid = 0;

    if (dataIn.ostammid) this.ostammidload = dataIn.ostammid;

    this.loadSiObjekt(this.ostammidload);
  }

  @ViewChild(ClrForm, { static: false })
  private clrForm: ClrForm;

  private readonly previewAktiv = viewChild<PreviewThumbnailsComponent>('aktiv');
  private readonly previewÜbersicht = viewChild<PreviewThumbnailsComponent>('übersicht');
  mangelMedia: TitleAndFileNames[];
  showMangelMedia: boolean = false;

  @ViewChild(SonderinspektionmodalComponent)
  modal: SonderinspektionmodalComponent;

  protected formGroupSI = new UntypedFormGroup({
    bemerkung: new UntypedFormControl(''),
    zustand: new UntypedFormControl('', [Validators.required]),
    datum: new UntypedFormControl('', [Validators.required]),
  });

  protected sonderinspformGroup = new UntypedFormGroup({
    bemerkung: new UntypedFormControl(''),
    mangel: new UntypedFormControl(''),
    beginn: new UntypedFormControl('', [Validators.required]),
    aktiv: new UntypedFormControl(true),
    intervall: new UntypedFormControl(10, [Validators.required]),
  });

  protected objekteSonderModal: boolean = false;
  protected ostammidload: number = 0;
  protected ostammid: number = 0;
  protected otypid: number = 0;
  protected omazsid: number = 0;
  protected initdate: any;
  protected mangel: string = '';
  protected osispkID = 0;
  protected sonderPruefunglTable: any;
  protected curbilder: any = [];
  protected items: string[] = ['gut', 'schlecht', 'unverändert'];
  protected sonderPruefungen: any;
  protected textpreview: string = '';
  protected iconColumns: string[] = ['typ'];
  protected showsonderinspektion: boolean = false;
  protected beginn: any;
  protected intervall: any;
  protected selecteditem: any;
  protected selecteditemMangel: any;
  protected editid: number = 0;
  protected titel: string = '';



  loadSiObjekt(ostammid: number) {
    this.apiservice
      .getSonderinspektionListe(ostammid.toString())
      .pipe(first())
      .subscribe((val: any) => {
        this.textpreview = this.mrTranslate.transform('Es ist keine aktive Sonderinspektion vorhanden');
        this.loading = false;
        
        
        if (val.rows.length != 0) {
          this.sonderPruefungen = val;

          if (this.ostammidload != 0 && val.rows) {
            this.titel = ' • ' + val.rows[0]['Bezeichnung'];
          }
        }
      });
  }

  showNewSi() {
    this.formGroupSI.controls.datum.setValue(BackendLocaleDatePipe.now);
    this.formGroupSI.controls.zustand.setValue('');
    this.formGroupSI.controls.bemerkung.setValue('');
    this.objekteSonderModal = true;
    this.selecteditemMangel = undefined;
    this.editid = 0;
    setTimeout(() => {
      this.previewAktiv()?.clearPreview();
    }, 500);
  }

  async newSi() {
    this.clrForm.markAsTouched();
    if (this.formGroupSI.valid) {
      let images, altNames: string;
      try {
        images = await this.previewAktiv()?.packUnsavedFiles();
        altNames = this.previewAktiv()?.savedNames();
      } catch (_) {
        this.toastr.error(this.mrTranslate.transform('Beim Speichern von Bilder und Video ist ein Fehler aufgetreten'));
      }

      let val = this.formGroupSI.value;

      let sonder = {
        status: this.editid == 0 ? 'addpruefung' : 'updatepruefung',
        OSTAMMID: this.ostammid,
        OMAZSID: this.omazsid,
        OSISPKID: this.osispkID,
        OTYPID: this.otypid,
        BILDER: images,
        value: val,
        editid: this.editid,
        altNames: altNames,
      };

      this.apiservice
        .setSonderinspektion(sonder)
        .pipe(first())
        .subscribe((val: any) => {
          if (val.success) {
            if (this.sonderPruefunglTable == undefined) {
              this.sonderPruefunglTable = val.pruefung;
            } else this.sonderPruefunglTable.rows = val.pruefung.rows;

            this.items = val.zustand;
            this.toastr.success(
              this.mrTranslate.transform('Erfolgreich gespeichert'),
              this.mrTranslate.transform('Sonderinspektion')
            );
          }

          this.objekteSonderModal = false;
          this.selecteditemMangel = undefined;
          this.editid = 0;
        });
    }
  }

  saveSonderinspektion() {
    let val = this.sonderinspformGroup.value;

    if (val.aktiv == false) {
      let sonder = {
        status: 'closepruefung',
        OSTAMMID: this.ostammid,
        OMAZSID: this.omazsid,
        OSISPKID: this.osispkID,
        bemerkung: val.bemerkung,
      };

      this.apiservice
        .setSonderinspektion(sonder)
        .pipe(first())
        .subscribe((val: any) => {
          if (val.success) {
            this.dataRefresh?.emit(true);

            this.toastr.success(
              this.mrTranslate.transform('Sonderinspektion wurde beenden'),
              this.mrTranslate.transform('Sonderinspektion')
            );

            this.showsonderinspektion = false;

            this.apiservice
              .getSonderinspektionListe(this.ostammidload.toString())
              .pipe(first())
              .subscribe((val: any) => {
                this.sonderPruefungen.rows = val.rows;
                if (val.rows.length == 0) {
                  this.sonderPruefungen.rows = undefined;
                }
              });
          }
        });
    }
  }

  async editSi() {
    this.editid = this.selecteditemMangel.id;
    this.formGroupSI.controls.datum.setValue(this.selecteditemMangel.Datum);
    this.formGroupSI.controls.zustand.setValue(this.selecteditemMangel.Zustand);
    this.formGroupSI.controls.bemerkung.setValue(this.selecteditemMangel.Bemerkung);

    if (this.selecteditemMangel.bild) {
      let mangelMedia: TitleAndFileNames[] = this.media.parseMediaPath(this.selecteditemMangel.bild);
      let cb = await this.media.getApiFunctionMedia(mangelMedia[0]['fileNames']);
      this.previewAktiv().unpackFiles(cb);
    }

    this.objekteSonderModal = true;
  }

  async deleteSi() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie die Sonderinspektion löschen wollen?')
    );
    if (!ok) return;

    let sonder = {
      status: 'deletepruefung',
      OSTAMMID: this.ostammid,
      OMAZSID: this.omazsid,
      OSISPKID: this.osispkID,
      OTYPID: this.otypid,
      editid: this.selecteditemMangel.id,
    };

    this.apiservice
      .setSonderinspektion(sonder)
      .pipe(first())
      .subscribe((val: any) => {
        if (val.success) {
          this.sonderPruefunglTable.rows = val.pruefung.rows;
          this.items = val.zustand;

          this.toastr.success(
            this.mrTranslate.transform('Erfolgreich gespeichert'),
            this.mrTranslate.transform('Sonderinspektion')
          );
        }

        this.objekteSonderModal = false;
        this.selecteditemMangel = undefined;
        this.editid = 0;
      });
  }

  async exitSi() {
    const ok = await this.confirmService.warning(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Sonderinspektion beenden wollen?')
    );
    if (!ok) return;

    let inData = {
      Status: 0,
      OSTAMMID: this.ostammid,
      OMAZSID: this.omazsid,
      OSISPKID: this.osispkID,
      Mangel: this.mangel,
      aktive: false,
      beginn: this.beginn,
      intervall: this.intervall,
    };
    this.modal.open(inData);

    this.modal.onOK.subscribe(res => {
      if (res == true) {
        this.modal.close();
        this.dataRefresh?.emit(true);
        this.apiservice
          .getSonderinspektionListe(this.ostammidload.toString())
          .pipe(first())
          .subscribe((val: any) => {
            this.sonderPruefungen.rows = val.rows;
            if (val.rows.length == 0) {
              this.sonderPruefungen.rows = undefined;
            }
          });
      }
    });
  }

  selectionTabelleItemChanged(val: any) {
    if (val != undefined) {
      this.curbilder = [];

      setTimeout(() => {
        this.previewÜbersicht().clearPreview();
        if (this.curbilder.length > 0) {
          this.previewÜbersicht().unpackFiles([...this.curbilder]);
        }
      }, 200);
    }
  }

  selectionTabelleTitelChanged(val: any) {
    if (val != undefined) {
      this.curbilder = [];
      this.osispkID = val.ID;
      this.ostammid = val.OSTAMMID;
      this.otypid = val.OTYPID;
      this.omazsid = val.OMAZSID;
      this.mangel = val.Mangel;
      this.beginn = val.Beginn;
      this.intervall = val.Intervall;

      this.loadSonderinspektionObjekt();
    }
  }

  loadSonderinspektionObjekt() {
    this.apiservice
      .getSonderinspektion(this.osispkID.toString(), this.otypid.toString())
      .pipe(first())
      .subscribe((val: any) => {
        if (this.sonderPruefunglTable == undefined) {
          this.sonderPruefunglTable = val.pruefung;
        } else this.sonderPruefunglTable.rows = val.pruefung.rows;

        if (val.zustand) {
          this.items = val.zustand;
        }
      });
  }

  public close() {
    this.closedialog.next(true);
  }
}
